import { useNexaControl } from '@src/globalStore/controlsStore';
import { useFeature } from '@src/globalStore/featureStore';
import {
  checkIsInternalUser,
  checkIsAdminUser,
  checkCanEnableNexa,
} from '@src/globalStore/profileStore';
import featureNames from '@src/utils/featureToggle/constants';
import { logger } from '@src/utils/misc/logger';

export enum NexaGateState {
  DISABLED = 'disabled',
  ALLOWED = 'allowed',
  BLOCKED = 'blocked',
}

export const useNexaGateCheck = (): { state: NexaGateState; canEnable: boolean } => {
  const featureEnabled = useFeature(featureNames.NEXA);
  const nexaControl = useNexaControl();
  const isAdmin = checkIsAdminUser();
  const canEnableNexa = checkCanEnableNexa();
  const isInternalUser = checkIsInternalUser(); // for future use

  // Feature flag is off
  if (!featureEnabled) {
    return { state: NexaGateState.DISABLED, canEnable: false };
  }

  // Nexa access is enabled
  if (nexaControl?.status) {
    return { state: NexaGateState.ALLOWED, canEnable: isAdmin && canEnableNexa };
  }

  // Blocked - admin can enable, non-admin cannot
  return { state: NexaGateState.BLOCKED, canEnable: isAdmin && canEnableNexa };
};
